import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type PostReportExportRequest = {
  reportType: string;
  startAt: Date;
  endAt: Date;
  wasteStreamIds: number[];
  suburbs: string[];
  streets: string[];
  collectionIssueTypeCategories: number[];
  collectionEventIds: number[];
  letterTemplateNames: string[];
};

export const postReportExport = async (request: PostReportExportRequest) => {
  const response = await executeApiRequest(
    () => axios.post<Blob>("/reports/export", request, { responseType: "blob", withCredentials: true }),
    false
  );

  const blobData = new Blob([response.data]);
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "export.csv");
  document.body.appendChild(link);
  link.click();

  return response.data;
};
